/*
 Copyright 2026 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Blueprint API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DataFieldType = {
    String: 'String',
    Integer: 'Integer',
    Double: 'Double',
    Boolean: 'Boolean',
    DateTime: 'DateTime',
    Organization: 'Organization',
    Html: 'Html',
    Card: 'Card',
    SourceType: 'SourceType',
    Team: 'Team',
    TeamsMultiple: 'TeamsMultiple',
    Status: 'Status',
    User: 'User',
    Checkbox: 'Checkbox',
    Url: 'Url',
    Move: 'Move'
} as const;
export type DataFieldType = typeof DataFieldType[keyof typeof DataFieldType];

